import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Button, { SKINS } from '../button/button';
import ChannelActionsContainer from '../../../containers/channel-actions/channel-actions';
import { isSubscriptionButtonVisible } from '../../../components/overlay-texts/channel/subscribe-button-text-utils';
import ChannelSubscriptionLabel from '../../../components/channel-subscription-label/channel-subscription-label';

function SubscribeChannelButton({ channel, onPageRefresh, skin, className }) {
  if (!isSubscriptionButtonVisible({ channel })) {
    return null;
  }

  return (
    <ChannelActionsContainer
      onPageRefresh={onPageRefresh}
      channelId={channel.id}
    >
      {(channelActions) => (
        <Button
          onClick={channelActions.subscribe}
          skin={skin}
          className={className}
        >
          <ChannelSubscriptionLabel dealInfo={channel.dealInfo} />
        </Button>
      )}
    </ChannelActionsContainer>
  );
}

SubscribeChannelButton.propTypes = {
  channel: PropTypes.object.isRequired,
  onPageRefresh: PropTypes.func,
  skin: PropTypes.oneOf(_.values(SKINS)),
  className: PropTypes.string,
};

export { SKINS };
export default SubscribeChannelButton;
